import { render, staticRenderFns } from "./ButtonGoTo.vue?vue&type=template&id=1c70efb5&"
import script from "./ButtonGoTo.vue?vue&type=script&lang=js&"
export * from "./ButtonGoTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports